import "ace-builds";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-github";
import classNames from "classnames";
import { ReactNode } from "react";
import AceEditor from "react-ace";
import { zIndexes } from "utils/zIndexes.ts";

const LINES_COUNT = 3;

interface CodeEditorProps {
    id: string;
    children: ReactNode;
    wrapEnabled?: boolean;
    readOnly?: boolean;
    className?: string;
    minLines?: number;
    maxLines?: number;
}

export const CodeEditor = ({
    className,
    id,
    children,
    wrapEnabled,
    readOnly = true,
    minLines,
    maxLines,
}: CodeEditorProps) => {
    if (!children) {
        return null;
    }

    // Try to parse and prettify JSON, fall back to raw text if invalid
    const formatValue = (input: string): string => {
        try {
            return JSON.stringify(JSON.parse(input), null, 2);
        } catch {
            return input;
        }
    };

    return (
        <AceEditor
            name={id}
            mode={"json"}
            theme="github"
            minLines={minLines ?? LINES_COUNT}
            maxLines={maxLines ?? LINES_COUNT}
            className={classNames(`min-w-[318px] !w-full z-${zIndexes.codeEditor}`, className)}
            wrapEnabled={wrapEnabled}
            readOnly={readOnly}
            value={formatValue(children.toString())}
        />
    );
};
